// Light/outline icon set for the Navbar products launcher.
// Hand-drawn (thin stroke, no fill) instead of a new icon-library dependency —
// node_modules here is root-owned so `npm install` fails with EACCES; this keeps
// the launcher unblocked without touching permissions. Same 24x24 stroke
// conventions as Lucide/Feather so they read as "light" icons, matching the mockup.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function HomeIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <path d="M4 10.5 12 4l8 6.5" />
      <path d="M6 9.5V19a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1V9.5" />
    </svg>
  );
}

export function ServerIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <rect x="3.5" y="4" width="17" height="6.5" rx="1.5" />
      <rect x="3.5" y="13.5" width="17" height="6.5" rx="1.5" />
      <path d="M7 7.25h3M7 16.75h3" />
    </svg>
  );
}

export function NetworkIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <rect x="9.5" y="3" width="5" height="4.2" rx="1" />
      <rect x="3.5" y="16.8" width="5" height="4.2" rx="1" />
      <rect x="15.5" y="16.8" width="5" height="4.2" rx="1" />
      <path d="M12 7.2v4.3M12 11.5H6v5.3M12 11.5h6v5.3" />
    </svg>
  );
}

export function DatabaseIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <ellipse cx="12" cy="5.2" rx="7" ry="2.4" />
      <path d="M5 5.2V11c0 1.33 3.13 2.4 7 2.4s7-1.07 7-2.4V5.2" />
      <path d="M5 11v6.8c0 1.33 3.13 2.4 7 2.4s7-1.07 7-2.4V11" />
    </svg>
  );
}

export function CloudIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <path d="M7.2 18.4h10a4 4 0 0 0 .5-7.97 5.5 5.5 0 0 0-10.6 1.8 3.6 3.6 0 0 0-1.7 6.6c.55.36 1.2.57 1.8.57Z" />
    </svg>
  );
}

export function ActivityIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <path d="M2.5 12.5h4l2-7 4 14 2-7h6.5" />
    </svg>
  );
}

export function ShieldIcon({ className }) {
  return (
    <svg {...base} className={className}>
      <path d="M12 3.2 19 6v5.4c0 4.6-3 7.7-7 9.4-4-1.7-7-4.8-7-9.4V6l7-2.8Z" />
    </svg>
  );
}

export function GridIcon({ className }) {
  return (
    <svg {...base} className={className} strokeWidth={1.6}>
      <circle cx="5" cy="5" r="1.4" />
      <circle cx="12" cy="5" r="1.4" />
      <circle cx="19" cy="5" r="1.4" />
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
      <circle cx="5" cy="19" r="1.4" />
      <circle cx="12" cy="19" r="1.4" />
      <circle cx="19" cy="19" r="1.4" />
    </svg>
  );
}
